var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wa--status-panel wa--panel bx--aspect-ratio bx--aspect-ratio--2x1"},[_c('span',{staticClass:"wa--status-text"},[_vm._t("default")],2),_c('span',{staticClass:"wind--text-divider"}),_c('span',{class:['wa--status-indicator', `wa--status-${_vm.status}`]},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }